import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import styled from 'styled-components';

export const Button = styled.button`
    border-width: 0;
    border-radius: 5px;
    width: ${SIZE.TWENTYTHREE}px;
    height: ${SIZE.FOUR + SIZE.HALF}px;
    flex-grow: 0;
    margin-top: 30px;
    background-color: #4da0ff;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;

    &:disabled {
        background-color: #bdbdbd;
        border: none;
    }

    &:hover {
        cursor: pointer;
    }
}
`
